export default {
      id: "pending-projects-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons-sprite.03ac376.svg#pending-projects-usage",
      toString: function () {
        return this.url;
      }
    }